import React, {
    useContext,
    useState,
} from 'react';
import { useQuery } from '@tanstack/react-query';


import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import BasketTicketItem from './basket-ticket-item';
import LoadingIndicator from '../components/loading-indicator';
import Logo from '../svg/logo';

export default function BasketEvent (props) {

    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.event.event_id],
        queryFn: () => QUERIES.getEventImage(props.event.event_id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    return (
        <div className='basket-item'>
            <div className='basket-item__image'>
                {isPending || isFetching ?
                    <LoadingIndicator />
                : imageData ?
                    <div className='basket-item__image--wp' dangerouslySetInnerHTML={{__html: imageData}}></div>
                : props.event.event_image ?
                    <img src={props.event.event_image } className='basket-item__image--spektrix' />
                :
                    <Logo />
                }
            </div>
            <div className='basket-item__summary instance-event-summary'>
                <h2 className='basket-item__title instance-event-summary__title'>{props.event.event_name}</h2>
                <p className='basket-item__date instance-event-summary__date'>{props.event.instance_date}</p>
                <p className='basket-item__venue instance-event-summary__venue'>{props.event.event_venue}</p>
            </div>
            <ul className='basket-item__ticket-list' role="list">
                {props.event.tickets?.map((ticket) => (
                    <BasketTicketItem key={ticket.id} ticket={ticket} />
                ))}
            </ul>
        </div>
    )
}